import { Dispatch, SetStateAction } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  InputAdornment,
  TextField
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Facet, FilterOption } from 'types/Search';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { tss } from 'tss-react/mui';

interface FilterAccordionProps {
  option: FilterOption;
  selectedFilters?: Facet[];
  filteredFilters?: Facet[];
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  children: React.ReactNode;
  expanded: boolean | string;
  setExpanded: Dispatch<SetStateAction<boolean | string>>;
}

const FilterAccordion: React.FC<FilterAccordionProps> = ({
  option,
  children,
  searchQuery,
  setSearchQuery,
  filteredFilters,
  expanded,
  setExpanded
}) => {
  const handleChange =
    (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  const { classes } = useStyles();

  return (
    <Box>
      <Divider
        sx={{
          borderColor: ({ palette }) => palette.divider
        }}
      />

      <Accordion
        expanded={expanded === option.key}
        onChange={handleChange(option.key)}
        disabled={filteredFilters?.length === 0}
        classes={{ disabled: classes.disabled }}
        slotProps={{ transition: { unmountOnExit: true } }}
      >
        <AccordionSummary
          expandIcon={filteredFilters?.length === 0 ? null : <ExpandMoreIcon />}
          classes={{
            root: classes.root,
            content: classes.content
          }}
          sx={{
            transition: 'none',
            color: '#343434',
            fontSize: '14px',
            fontWeight: 300,
            textTransform: 'uppercase'
          }}
        >
          {option.label}
        </AccordionSummary>
        {expanded === option.key && (
          <AccordionDetails sx={{ paddingTop: 0 }}>
            <Box sx={{ marginBottom: 1 }}>
              <TextField
                size="small"
                hiddenLabel
                fullWidth
                value={searchQuery}
                autoComplete="off"
                onChange={e => {
                  setSearchQuery(e.target.value);
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onKeyDown={e => e.stopPropagation()}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    )
                  }
                }}
              />
            </Box>
            {children}
          </AccordionDetails>
        )}
      </Accordion>
    </Box>
  );
};

export default FilterAccordion;
const useStyles = tss.create(() => ({
  root: { '&&': { minHeight: 'unset', margin: `9px 0 7px 0` } },
  content: { '&&': { margin: 0 } },
  disabled: {
    '&&': {
      backgroundColor: 'inherit'
    }
  }
}));
